import { useEffect } from 'react';
import { Navigate, useRoutes, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import IpQualityCheckPage from '../pages/IpQualityCheckPage';
import IpToTimeAndLanguageCheckPage from '../pages/IpToTimeAndLanguageCheckPage';
import IpToCurrencyCheckPage from '../pages/IpToCurrencyCheckPage';
import MobileNumberVerificationCheckPage from '../pages/MobileNumberVerificationCheckPage';
import DashboardLayout from '../layouts/dashboard';
import UserPage from '../pages/UserPage';
import LoginPage from '../pages/LoginPage';
import Page404 from '../pages/Page404';
import SignUpPage from '../pages/SignUpPage';
import LandingRoute from '../landingPage/LandingRoute';
import ForgotPasswordPage from '../pages/ForgotPasswordPage';
import About from '../landingPage/page/About';
import FAQPage from '../landingPage/page/FAQPage';
import PrivacyPolicy from '../landingPage/page/PrivacyPolicy';
import ServiceDeliveryPolicy from '../landingPage/page/ServiceDeliveryPolicy';
import TermsAndConditions from '../landingPage/page/TermsAndConditions';
import LogOut from '../pages/LogOut';
import UpdatePasswordPage from '../pages/UpdatePasswordPage';
import SubscriptionPage from '../sections/@dashboard/subscription/SubscriptionPage';
import ProfilePage from '../pages/ProfilePage';
import WalletPage from '../pages/WalletPage';
import TestimonialPage from '../landingPage/page/TestimonialPage';
import SubscriptionPricingPage from '../pages/SubscriptionPricingPlan';
import ContactSales from '../pages/ContactSales';
// import NewsUpdate from '../pages/NewsUpdate';
import { SuccessPage } from '../sections/@dashboard/razorpayPayment';
import DocumentationPage from '../pages/DocumentationPage';
import { getUserRole, isLoggedIn } from './authUtils';
import DocumentDetailPage from '../landingPage/page/DocumentDetailPage';
import DashboardPage from '../pages/DashboardPage';

// ----------------------------------------------------------------------

export default function RouterConfig() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn() && window.location.pathname.startsWith('/dashboard')) {
      navigate('/login');
    }
  }, [navigate]);

  const adminRoutes = [
    {
      path: '/',
      element: <LandingRoute />,
      children: [{ element: <Navigate to="/" />, index: true }],
    },
    {
      path: '/dashboard',
      element: isLoggedIn() ? <DashboardLayout isAdmin /> : <Navigate to="/login" />,
      children: [
        { path: '', element: <Navigate to="/dashboard/admin" /> },
        { path: 'admin', element: <UserPage /> },
        { path: 'users', element: <UserPage /> },
        { path: 'contact-sales', element: <ContactSales /> },
        { path: 'contact-sales/:userId', element: <ContactSales /> },
        // { path: 'news-update', element: <NewsUpdate /> },
        { path: 'profile', element: <ProfilePage /> },
        {
          path:'ipQualityCheck',
          element:<IpQualityCheckPage/>
        },
        {
          path:'ipToCurrencyCheck',
          element:<IpToCurrencyCheckPage/>
        },
        {
          path:'ipToTimeAndLanguageCheck',
          element:<IpToTimeAndLanguageCheckPage/>
        },
        {
          path:'MobileNumberVerificationCheckPage',
          element:<MobileNumberVerificationCheckPage />
        }
      ],
    },
    {
      path: '/login',
      element: <LoginPage />,
    },
    {
      path: '/logout',
      element: <LogOut />,
    },
    {
      path: '/signup',
      element: <SignUpPage />,
    },
    {
      path: '*',
      element: <Page404 />,
    },
    {
      path: '/forgotPassword',
      element: <ForgotPasswordPage />,
    },
    {
      path: '/updatePassword',
      element: <UpdatePasswordPage />,
    },
    {
      path: '/about',
      element: <About />,
    },
    {
      path: '/faq',
      element: <FAQPage />,
    },
    // {
    //   path: '/document',
    //   element: <Documentation />,
    // },
    {
      path: '/testimonial',
      element: <TestimonialPage />,
    },
    {
      path: '/documentation',
      element: <DocumentDetailPage />,
    },
    {
      path: '/privacyPolicy',
      element: <PrivacyPolicy />,
    },
    {
      path: '/serviceDeliveryPolicy',
      element: <ServiceDeliveryPolicy />,
    },
    {
      path: '/termsAndConditions',
      element: <TermsAndConditions />,
    },
  ];

  const userRoutes = [
    {
      path: '/',
      element: <LandingRoute />,
      children: [{ element: <Navigate to="/" />, index: true }],
    },
    {
      path: '/dashboard',
      element: isLoggedIn() ? <DashboardLayout /> : <Navigate to="/login" />,
      children: [
        { element: <Navigate to="/dashboard/app" />, index: true },
        { path: 'app', element: <DashboardPage /> },
        { path: 'wallet', element: <WalletPage /> },
        { path: 'profile', element: <ProfilePage /> },
        { path: 'subscription', element: <SubscriptionPricingPage /> },
        {
          path: '/dashboard/documentation',
          element: <DocumentationPage />,
        },
        {
          path: '/dashboard/subscription/:_id',
          element: <SubscriptionPricingPage />,
        },
        {
          path: '/dashboard/subscription/:_id/:subscriptionName/:subscriptionAmount',
          element: <SubscriptionPricingPage />,
        },
        {
          path: '/dashboard/wallet/payment',
          element: <WalletPage />,
        },
        {
          path: '/dashboard/wallet/success',
          element: <SuccessPage />,
        },
        {
          path:'ipQualityCheck',
          element:<IpQualityCheckPage/>
        },
        {
          path:'ipToCurrencyCheck',
          element:<IpToCurrencyCheckPage/>
        },
        {
          path:'ipToTimeAndLanguageCheck',
          element:<IpToTimeAndLanguageCheckPage/>
        },
        {
          path:'MobileNumberVerificationCheck',
          element:<MobileNumberVerificationCheckPage />
        }
      ],
    },
    {
      path: '/dashboard/subscription',
      element: <SubscriptionPage />,
    },
    {
      path: '/login',
      element: <LoginPage />,
    },
    {
      path: '/signup',
      element: <SignUpPage />,
    },
    {
      path: '/logout',
      element: <LogOut />,
    },
    {
      path: '*',
      element: <Page404 />,
    },
    {
      path: '/forgotPassword',
      element: <ForgotPasswordPage />,
    },
    {
      path: '/updatePassword',
      element: <UpdatePasswordPage />,
    },
    {
      path: '/about',
      element: <About />,
    },
    {
      path: '/faq',
      element: <FAQPage />,
    },
    // {
    //   path: '/document',
    //   element: <Documentation />,
    // },
    {
      path: '/testimonial',
      element: <TestimonialPage />,
    },
    {
      path: '/documentation',
      element: <DocumentDetailPage />,
    },
    {
      path: '/privacyPolicy',
      element: <PrivacyPolicy />,
    },
    {
      path: '/serviceDeliveryPolicy',
      element: <ServiceDeliveryPolicy />,
    },
    {
      path: '/termsAndConditions',
      element: <TermsAndConditions />,
    },
  ];

  const routes = useRoutes(getUserRole() === 'admin' ? adminRoutes : userRoutes);

  return (
    <>
      <Helmet>
        <title>InnoWave API Hub – Seamless &amp; Affordable API Solutions</title>
        <meta name="google-site-verification" content="ugYgzsB80lsq4-0bYyoTSa3p4vy2CHFgpG51ty883S4" />
        <meta
          name="description"
          content="Empower your applications with our seamless &amp; affordable API solutions, including geocoding, reverse geocoding, name matching, and mobile number verification."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="InnoWave API Hub – Seamless &amp; Affordable API Solutions designed for flexibility, reliability, and easy integration."
        />
        <meta
          property="og:description"
          content="Our APIs are designed for flexibility, reliability, and easy integration."
        />
        <meta property="og:keywords" content="InnoWave API Hub" />
        <meta property="og:image" content="https://www.innowave.solutions.com/path/to/image.jpg" />
        <meta property="og:url" content="https://www.innowave.solutions.com/" />
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            url: 'https://www.innowave.solutions.com/',
            name: 'InnoWave API Hub',
            description: 'InnoWave API Hub – Seamless &amp; Affordable API Solutions.',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://www.innowave.solutions.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
            mainEntity: {
              '@type': 'WebPage',
              '@id': 'https://www.innowave.solutions.com/',
              name: 'InnoWave API Hub',
              description: 'Explore our comprehensive InnoWave API Hub designed to optimize performance.',
            },
            subEntity: [
              {
                '@type': 'WebPage',
                '@id': 'https://www.innowave.solutions.com',
                name: 'Server Health Metrics',
                description: 'Get insights into your server health with detailed metrics and reports.',
              },
            ],
          })}
        </script>
      </Helmet>
      {routes}
    </>
  );
}
